module.exports = __webpack_public_path__ + "static/img/1.8e8f25c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/6/1.png
// module id = OUw+
// module chunks = 0